module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[77]320.4502c20.woff2";